import { defineStore } from 'pinia'

export const useSearchStore = defineStore('search', {
  state: () => ({
    isOvernight: false,
    results: [],
  }),
  actions: {
    setIsOvernight(isOvernight) {
      this.isOvernight = isOvernight;
    },
    setResults(results) {
      this.results = results;
    },
    clearOvernight() {
      this.isOvernight = false;
    }
  },
  getters: {
    overnight: (state) => state.isOvernight,
  },
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
});
